import React, { createContext, useState, useContext } from 'react';

const FooterContext = createContext();

export const FooterProvider = ({ children, initialHidden = false }) => {
  const [showFooter, setShowFooter] = useState(!initialHidden);
  
  return (
    <FooterContext.Provider value={{ showFooter, setShowFooter }}>
      {children}
    </FooterContext.Provider>
  );
};

export const useFooter = () => useContext(FooterContext); 